import { render, staticRenderFns } from "./LayoutContent.vue?vue&type=template&id=4b7f92f4&scoped=true"
import script from "./LayoutContent.vue?vue&type=script&lang=js"
export * from "./LayoutContent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b7f92f4",
  null
  
)

export default component.exports